import React from 'react';
import LandingPage from './LandingPage';

const WeddingBartenderHalifax = () => {
  return <LandingPage />;
};

export default WeddingBartenderHalifax;